var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function ExternalLink(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd", d: "M6 2a1 1 0 0 1 .117 1.993L6 4H4.778a.779.779 0 0 0-.771.672L4 4.778v8.444c0 .394.293.719.672.771l.106.007h8.444a.779.779 0 0 0 .771-.672l.007-.106L13.993 12a1 1 0 0 1 1.993-.117l.007.117.007 1.222a2.779 2.779 0 0 1-2.609 2.773l-.169.005H4.778a2.779 2.779 0 0 1-2.773-2.609L2 13.222V4.778a2.778 2.778 0 0 1 2.609-2.773L4.778 2H6zm10 1.064V3l-.007-.117A1 1 0 0 0 15 2h-4l-.117.007A1 1 0 0 0 10 3l.007.117A1 1 0 0 0 11 4h1.488L7.312 9.183l-.089.1a1.06 1.06 0 0 0 .091 1.405 1.073 1.073 0 0 0 1.512-.002L14 5.507V7l.007.117A1 1 0 0 0 16 7V3.064z" }) })));
}
export default ExternalLink;
